import React, { useState } from 'react';
import { Phone, MessageCircle, User, X } from 'lucide-react';
import './styles/rider-details.css';
import CancelOrderModal from '@/pages/Profile/OrderDetails/components/CancelOrderModal';

interface RiderDetailsProps {
  riderName?: string;
  riderPhone?: string;
  vehicleNumber?: string;
  orderId?: string;
  orderStatus?: string;
  trackingStatus?: string;
  onOrderCancelled?: () => void;
}

const RiderDetails: React.FC<RiderDetailsProps> = ({
  riderName = 'Not Assigned',
  riderPhone,
  vehicleNumber,
  orderId,
  orderStatus,
  trackingStatus,
  onOrderCancelled
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  
  const handleCallRider = () => {
    if (riderPhone) {
      window.location.href = `tel:${riderPhone}`;
    }
  };

  const handleChatSupport = () => {
    const phoneNumber = '7617610660';
    const message = `Hey I need help with my order${orderId ? ` ${orderId}` : ''}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="rider-details-container">
      <div className="rider-info-section">
        <div className="rider-info-item">
          <User size={18} color="#666" />
          <span className="rider-label">Rider:</span>
          <span className="rider-value">{riderName}</span>
        </div>
        {vehicleNumber && (
          <div className="rider-info-item">
            <span className="rider-label">Vehicle:</span>
            <span className="rider-value">{vehicleNumber}</span>
          </div>
        )}
      </div>
      
      <div className="rider-actions">
        <div className="rider-main-actions">
          <button 
            className="rider-btn call-rider-btn"
            onClick={handleCallRider}
            disabled={!riderPhone}
          >
            <Phone size={16} />
            Call Rider
          </button>
          <button 
            className="rider-btn chat-support-btn"
            onClick={handleChatSupport}
          >
            <MessageCircle size={16} />
            Chat Support
          </button>
        </div>
        {['pending', 'paid'].includes(orderStatus?.toLowerCase() || '') && trackingStatus?.toLowerCase() !== 'out_for_delivery' && (
          <div className="rider-cancel-action">
            <button 
              className="rider-btn cancel-order-btn"
              onClick={() => setShowCancelModal(true)}
            >
              <X size={16} />
              Cancel Order
            </button>
          </div>
        )}
      </div>
      
      {showCancelModal && orderId && (
        <CancelOrderModal
          orderId={orderId}
          orderStatus={orderStatus || ''}
          trackingStatus={trackingStatus || ''}
          onClose={() => setShowCancelModal(false)}
          onSuccess={() => {
            setShowCancelModal(false);
            onOrderCancelled?.();
          }}
        />
      )}
    </div>
  );
};

export default RiderDetails;
